import { createContext, useContext } from 'react';
import useFetchAccountFeatureConfigs, { SEAAccountFeatureConfigsResponse } from '../data/useFetchAccountFeatureConfigs';
import useUserDetails from '../data/useUserDetails';

export interface AccountFeatureConfigsContextValue {
  accountFeatureConfigs: SEAAccountFeatureConfigsResponse['data'] | null;
}

export const AccountFeatureConfigsContext = createContext<AccountFeatureConfigsContextValue | null>(null);

export const AccountFeatureConfigsProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: userDetails } = useUserDetails();
  // Return the account id of the primary account of the currently logged in user or null if not found
  const accountId = userDetails?.me?.account?.id || null;
  // Fetch the account configuration details for the primary account of the currently logged in user
  // If the there is no account id returned from the user details, return null
  const { data: accountFeatureConfigs } = useFetchAccountFeatureConfigs(accountId);

  const value: AccountFeatureConfigsContextValue = { accountFeatureConfigs: accountFeatureConfigs ?? null };

  return <AccountFeatureConfigsContext.Provider value={value}>{children}</AccountFeatureConfigsContext.Provider>;
};

export const useAccountFeatureConfigsContext = () => {
  const context = useContext(AccountFeatureConfigsContext);

  if (!context) {
    throw new Error('useAccountFeatureConfigsContext must be used within AccountFeatureConfigsProvider');
  }

  return context;
};
